import DOMPurify from 'dompurify';

// Official DOMPurify solution for target="_blank"
// Add a hook to make all links open a new window
DOMPurify.addHook('afterSanitizeAttributes', node => {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    node.setAttribute('rel', 'noopener noreferrer');
  }

  // set non-HTML/MathML links to xlink:show=new
  if (
    !node.hasAttribute('target') &&
    (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
  ) {
    node.setAttribute('xlink:show', 'new');
  }
  // end of DOMPurify official solution

  // remove opentracking pixel. can't be in useHtmlAdjustedToTheme, because setting innerHTML prop invokes img src calls
  if (node.localName === 'img' && node.height === 1 && node.width === 1) {
    node.parentNode.removeChild(node);
  }

  // needed to avoid errors when browser tries to render images while linked resource is not loaded yet
  if (node.localName === 'img' && node.src && node.src.startsWith('cid:')) {
    node.dataset.source = node.src;
    node.src = '';
  }
});

export const highlightTextInElements = (elementsArray, searchText) => {
  const regex = new RegExp(`(${searchText})`, 'gi');

  elementsArray.forEach(element => {
    element.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const matches = node.nodeValue.match(regex);

        if (matches) {
          const fragment = document.createDocumentFragment();

          matches.forEach(match => {
            const markElement = document.createElement('mark');
            markElement.textContent = match;
            fragment.appendChild(markElement);
          });

          const precedingText = node.nodeValue.substring(0, node.nodeValue.indexOf(matches[0]));
          const followingText = node.nodeValue.substring(
            node.nodeValue.indexOf(matches[matches.length - 1]) +
              matches[matches.length - 1].length,
          );

          if (precedingText) {
            const precedingTextNode = document.createTextNode(precedingText);
            element.insertBefore(precedingTextNode, node);
          }

          element.insertBefore(fragment, node);

          if (followingText) {
            node.nodeValue = followingText;
          }

          if (!followingText) {
            element.removeChild(node);
          }
        }
      }
    });
  });
};
